require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var math = Math;
exports.abs = math.abs;
exports.min = math.min;
exports.max = math.max;
exports.floor = math.floor;
exports.round = math.round;
exports.sqrt = math.sqrt;
exports.pow = math.pow;
exports.cos = math.cos;
exports.asin = math.asin;
exports.sin = math.sin;
exports.tan = math.tan;
exports.PI = math.PI;
exports.QUADRATIC_RATIO = 2.0 / 3;
exports.EPSILON = exports.pow(2, -52);